import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';

// ---- Xero slice 1: connection status, connect (OAuth), organisation pick, test, go-live date, disconnect ----

export type XeroStatus = 'NOT_CONNECTED' | 'CONNECTED' | 'NEEDS_RECONNECT';
/** The server never sends tokens; this is everything the screen may show. */
export interface XeroConnection {
    provider: string; serverReady: boolean; addonOn: boolean; status: XeroStatus; orgName: string | null;
    connectedAt: string | null; connectedByName: string | null; goLiveDate: string | null;
}
export interface XeroOrgChoice { tenantId: string; name: string; }

/** sessionStorage key: which institution started the Xero sign-in, read back on the callback page. */
export const XERO_CONNECT_KEY = 'xeroConnect';

export const XeroService = {
    view: async (i: string): Promise<XeroConnection> => (await axios.get(ENDPOINTS.XERO.VIEW(i))).data,
    connect: async (i: string): Promise<{ authorizeUrl: string }> => (await axios.post(ENDPOINTS.XERO.CONNECT(i))).data,
    callback: async (i: string, code: string, state: string): Promise<XeroOrgChoice[]> =>
        (await axios.post(ENDPOINTS.XERO.CALLBACK(i), { code, state })).data,
    pick: async (i: string, tenantId: string): Promise<XeroConnection> => (await axios.post(ENDPOINTS.XERO.PICK(i), { tenantId })).data,
    test: async (i: string): Promise<XeroConnection> => (await axios.post(ENDPOINTS.XERO.TEST(i))).data,
    setGoLive: async (i: string, goLiveDate: string): Promise<XeroConnection> =>
        (await axios.put(ENDPOINTS.XERO.GO_LIVE(i), { goLiveDate })).data,
    disconnect: async (i: string): Promise<XeroConnection> => (await axios.delete(ENDPOINTS.XERO.DISCONNECT(i))).data,
    /** Leaves the app for the Xero sign-in page (a separate function so tests can stub the page change). */
    redirect: (url: string): void => { window.location.assign(url); },
};

/** The server's own refusal text (plain string or {message}), else the fallback. */
export function xeroErrorText(e: any, fallback: string): string {
    const data = e?.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
    return fallback;
}
